import { Box } from '@mui/material';

import { Link } from '@larvitu/shared/next/mui';

import type { HeaderContextProps } from '@larvitu/shared/react/context/feature-header-context';
import type { BoxProps } from '@mui/material';
import type { LinkProps } from 'next/link';
import type { ComponentType, FC } from 'react';

export interface SiteBrandProps extends BoxProps, Omit<Partial<HeaderContextProps>, 'height'> {
  href: LinkProps['href'];
  logo?: ComponentType<{ isScrolling?: boolean }>;
  label?: ComponentType<{ isScrolling?: boolean }>;
  isScrolling?: boolean;
}

/**
 * @deprecated
 */
export const SiteBrand: FC<SiteBrandProps> = ({
  href,
  isScrolling = false,
  sx,
  logo: Logo,
  label: Label,
  ...props
}) => (
  <Link
    sx={{
      ml: 0,
      mr: 'auto',
    }}
    ml={0}
    mr="auto"
    noLinkStyle
    href={href}
  >
    <Box
      sx={{
        ...sx,
        lineHeight: 0,
        position: 'relative',
        display: 'flex',
      }}
      {...props}
    >
      {Logo && <Logo isScrolling={isScrolling} />}
      {Label && <Label isScrolling={isScrolling} />}
    </Box>
  </Link>
);
